import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import router from 'src/router';
import * as flights from 'core/flights';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class FlightSearchFormHistoryComponent extends Vue {
    @Prop()
    redirect: boolean;

    @Prop()
    historyItems: flights.SearchHistoryItem[];

    getClassName(classValue: string) {
        return flights.BookingClass.classLabel(classValue);
    }

    onHistoryItemClick(item: flights.SearchHistoryItem) {
        (<any>this).$ga.sendEvent('flights.form', 'history.select', 'flights.form.history.select');

        const url = '/flights' + item.url;

        if (this.redirect
            || url === this.$router.currentRoute.fullPath) { // router do not reload same path so use href
            location.href = url;
        } else {
            router.push('/flights' + item.url);
        }
    }
}
